import { instance } from './axios.instance'
import { RENTAL_ENDPOINT } from './endpoints'

/**
 * 대여 상세
 * GET /api/rental/{id}
 * @param {string} id
 */
export const getToolsRentalDetail = id => instance.get(RENTAL_ENDPOINT.DETAIL(id))

/**
 * 대여 삭제
 * DELETE /api/rental/{id}
 * @param {string} id
 */
export const deleteToolRental = id => instance.delete(RENTAL_ENDPOINT.DELETE(id))

/**
 * 대여 수정
 * PATCH /api/rental/{id}
 * @param {string} id
 * @param {Object} data
 */
export const editToolsRental = (id, data) => instance.patch(RENTAL_ENDPOINT.EDIT(id), data)

/**
 * 대여 등록
 * POST /api/rental/create
 * @param {Object} data
 */
export const createToolsRental = data => instance.post(RENTAL_ENDPOINT.CREATE, data)

/**
 * 대여 목록
 * GET /api/rental/list
 * @param {Object} params
 */
export const getToolsRentalList = params => instance.get(RENTAL_ENDPOINT.LIST, { params })

/**
 * 교구재 반출 목록
 * GET /api/rental/inventory
 */
export const getToolsRentalInventory = () => instance.get(RENTAL_ENDPOINT.INVENTORY)

/**
 * 대여 반납 상태 변경
 * PATCH /api/rental/state
 * @param {Object} data
 */
export const changeRentalState = data => instance.patch(RENTAL_ENDPOINT.CHANGE_STATE, data)

/**
 * 자산, 강사 유효성 확인
 * POST /api/rental/valid
 * @param {Object} data
 * @param {string[]} data.tutorName
 * @param {string[]} data.toolsName
 * @param {string[]} data.toolsNum
 */
export const validToolsRental = data => instance.post(RENTAL_ENDPOINT.VALID, data)

/**
 * 대여 목록
 * GET /api/rental/grid
 */
export const getToolsRentalGrid = () => instance.get(RENTAL_ENDPOINT.GRID)
